module.exports = __webpack_public_path__ + "img/close.052fc9a5.svg";